// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid_grid__zNBn_","isReversed":"grid_isReversed__n2a0O"};